module.exports = __webpack_public_path__ + "assets/flags/fi.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/fi.svg
// module id = 500
// module chunks = 0